// Revival: "Complete the job" block. Keeps the total in sync, follows the main variant picker for "this item",
// and adds all checked items in one cart/add call (Rebuy Smart Cart opens on its own; Horizon gets a
// CartLinesUpdateEvent so the cart icon updates).
import { CartLinesUpdateEvent } from '@shopify/events';

const money = (cents) => {
  const fmt = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
  return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100);
};

function mainVariantId() {
  const input = document.querySelector('product-form-component input[name="id"], form[action$="/cart/add"] input[name="id"]:not(.rv-card__form input)');
  return input ? input.value : null;
}

function init(root) {
  if (root.dataset.rvReady) return;
  root.dataset.rvReady = '1';
  const boxes = () => [...root.querySelectorAll('input[type="checkbox"][data-variant-id]')];
  const self = root.querySelector('[data-rv-fbt-self]');
  const totalEl = root.querySelector('[data-rv-fbt-total]');
  const btn = root.querySelector('[data-rv-fbt-add]');
  const msg = root.querySelector('[data-rv-fbt-msg]');

  const update = () => {
    const checked = boxes().filter((b) => b.checked);
    totalEl.textContent = money(checked.reduce((s, b) => s + Number(b.dataset.price || 0), 0));
    btn.disabled = checked.length === 0;
    btn.textContent = checked.length > 1 ? `Add ${checked.length} items to cart` : 'Add to cart';
  };
  root.addEventListener('change', update);

  // Follow the main variant picker so "this item" matches what the shopper selected.
  document.addEventListener('variant:update', (e) => {
    const v = e.detail && e.detail.resource;
    if (v && self) {
      self.dataset.variantId = v.id;
      // Shelter and employee prices come from the server as "variantId:cents," pairs.
      const groups = Object.fromEntries((self.dataset.groupPrices || '').split(',').filter(Boolean).map((x) => x.split(':')));
      const price = groups[v.id] ? Number(groups[v.id]) : v.price;
      self.dataset.price = price;
      const pe = root.querySelector('[data-rv-fbt-self-price]');
      if (pe) pe.textContent = money(price);
      update();
    }
  });

  btn.addEventListener('click', async () => {
    const mainId = mainVariantId();
    if (self && mainId) self.dataset.variantId = mainId;
    const items = boxes().filter((b) => b.checked).map((b) => ({ id: Number(b.dataset.variantId), quantity: 1 }));
    if (!items.length) return;
    btn.disabled = true; msg.textContent = '';
    const deferred = CartLinesUpdateEvent.createPromise();
    root.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    }));
    try {
      const res = await fetch((window.Theme?.routes?.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items }),
      });
      const data = await res.json();
      if (data.status) { deferred.reject(new Error(data.message)); msg.textContent = data.description || 'Some items could not be added.'; return; }
      const cart = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'revival-bundle-add', itemCount: items.length, didError: false } });
      msg.textContent = `Added ${items.length} item${items.length > 1 ? 's' : ''} to your cart.`;
    } catch (err) {
      deferred.reject(err); msg.textContent = 'Something went wrong. Please try again.';
    } finally {
      btn.disabled = false; update();
    }
  });
  update();
}

document.querySelectorAll('[data-rv-fbt]').forEach(init);
